module.exports = __webpack_public_path__ + "img/GBS_ETH-IND.a13918cd.webp";